Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrayField = exports.Field = exports.FieldError = exports.compileFieldConfig = exports.compileAllFields = exports.queryFieldsRegistry = exports.fieldsRegistry = void 0;
const registry_1 = require("./registry");
var registry_2 = require("./registry");
Object.defineProperty(exports, "fieldsRegistry", { enumerable: true, get: function () { return registry_2.fieldsRegistry; } });
Object.defineProperty(exports, "queryFieldsRegistry", { enumerable: true, get: function () { return registry_2.queryFieldsRegistry; } });
var fieldCompiler_1 = require("./compiler/fieldCompiler");
Object.defineProperty(exports, "compileAllFields", { enumerable: true, get: function () { return fieldCompiler_1.compileAllFields; } });
Object.defineProperty(exports, "compileFieldConfig", { enumerable: true, get: function () { return fieldCompiler_1.compileFieldConfig; } });
var error_1 = require("./error");
Object.defineProperty(exports, "FieldError", { enumerable: true, get: function () { return error_1.FieldError; } });
function Field(options) {
    return (targetInstance, fieldName) => {
        if (options &&
            options.hasOwnProperty('type') &&
            options.type === undefined) {
            console.log('This usually happens when a circular dependency is present. Wrap your explicit type in an arrow function to avoid this problem.');
            throw new TypeError(`Field "${fieldName}" on ${targetInstance.constructor} got an "undefined" as explicit type`);
        }
        const finalConfig = {
            property: fieldName,
            name: fieldName,
            isNullable: true,
            ...options
        };
        const existingField = registry_1.fieldsRegistry.get(targetInstance.constructor, fieldName);
        if (existingField) {
            if (!options.rootFieldType) {
                throw new TypeError(`Field "${fieldName}" on class ${targetInstance.constructor.name} cannot be registered-it's already registered as type ${existingField.type.name}`);
            }
            if (options.rootFieldType === existingField.rootFieldType) {
                throw new TypeError(`Root field "${fieldName}" on schema class ${targetInstance.constructor.name} cannot be registered as a ${existingField.rootFieldType}-it's already registered`);
            }
        }
        registry_1.fieldsRegistry.set(targetInstance.constructor, fieldName, finalConfig);
    };
}
exports.Field = Field;
/**
 * alias to help define array returning resolvers less verbosely and to enforce convention of arrays being not nullable
 * in real world scenarios you always want the array to be non nullable
 */
function ArrayField(options) {
    const typeOrCastTo = options ? options.itemType || options.itemCast : null;
    if (!typeOrCastTo) {
        throw new TypeError('ArrayField must have an explicit itemType or itemCast config');
    }
    return Field(options);
}
exports.ArrayField = ArrayField;
//# sourceMappingURL=Field.js.map